import React from 'react'

import CommonPieChart from './Components/CommonPieChart'
import CommonBarChart from './Components/CommonBarChart'
import CommonLineChart from './Components/CommonLineChart'
import { Link } from 'react-router-dom'
import CodeBox from '../../CodeBox'

const PeityCharts = () => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className='card h-100'>
                    <div className="rounded-4 mb-3 mb-sm-0 bg-white">
                        <div className="card-body">
                            <div className="px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
                                {/* // x---------------------------------x Peity Charts Section x---------------------------------x */}
                                <h4 className="mb-4">Peity Charts</h4>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <h5>How it works</h5>
                                        <p className="lead">Peity (sounds like deity) is a plugin that converts an element's content into a mini <code>svg</code> pie, donut, line or bar chart. <Link to="http://benpickles.github.io/peity/">Peity Chart</Link></p>
                                    </div>
                                    <div className="col-12">
                                        <h5 className="card-title">Pie Charts</h5>
                                        <div className="d-flex">
                                            <span className='me-1'><CommonPieChart className='' data={1} total={5} /></span>
                                            <span className='me-1'><CommonPieChart className='' data={226} total={360} /></span>
                                            <span className='me-1'><CommonPieChart className='' data={0.52} total={1.561} /></span>
                                            <span className='me-1'><CommonPieChart className='' data={1} total={4} /></span>
                                            <span className='me-1'><CommonPieChart className='' data={226} total={134} /></span>
                                            <span className='me-1'><CommonPieChart className='' data={0.52} total={1.041} /></span>
                                            <span className='me-1'><CommonPieChart className='' data={1} total={2.5} /></span>
                                        </div>
                                        <div className="language-html m-0 rounded-4 mt-3" data-lang="html">
                                            <pre className='h6 text-black'><code>**HTML**</code></pre>
                                            <CodeBox code={`<span className="pie">1/5</span>`} auto={true} />
                                        </div>
                                        <div className="language-html m-0 rounded-4 mt-3" data-lang="html">
                                            <pre className='h6 text-black'><code>**JavaScript**</code></pre>
                                            <CodeBox code={`<CommonPieChart className='pie' data=1 total=5 />`} auto={true} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <h5 className="card-title fw-normal mb-0">Line Charts</h5>
                                        <span className='me-1'><CommonLineChart className='line' data={[5, 3, 9, 6, 5, 9, 7, 3, 5, 2]} /></span>
                                        <span className='me-1'><CommonLineChart className='line' data={[5, 3, 2, -1, -3, -2, 2, 3, 5, 2]} /></span>
                                        <span className='me-1'><CommonLineChart className='line' data={[-1, -3, -6, -4, -5, -4, -7, -3, -5, -2]} /></span>
                                        <div className="language-html m-0 rounded-4 mt-3" data-lang="html">
                                            <pre className='h6 text-black'><code>**HTML**</code></pre>
                                            <CodeBox code={`<span className="line">5,3,9,6,5,9,7,3,5,2</span>`} auto={true} />
                                        </div>
                                        <div className="language-html m-0 rounded-4 mt-3" data-lang="html">
                                            <pre className='h6 text-black'><code>**JavaScript**</code></pre>
                                            <CodeBox code={`<CommonLineChart className='line' data={[5, 3, 9, 6, 5, 9, 7, 3, 5, 2]} />`} auto={true} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <h5 className="card-title fw-normal mb-0">Bar Charts</h5>
                                        <span className='me-1'><CommonBarChart className='bar' data={[5, 3, 9, 6, 5, 9, 7, 3, 5, 2]} /></span>
                                        <span className='me-1'><CommonBarChart className='bar' data={[5, 8, 9, 4]} /></span>
                                        <span className='me-1'><CommonBarChart className='bar' data={[8, 9, 10, 5, 4, 3, 2, 1]} /></span>
                                        <div className="language-html m-0 rounded-4 mt-3" data-lang="html">
                                            <pre className='h6 text-black'><code>**HTML**</code></pre>
                                            <CodeBox code={`<span className="bar">5,3,9,6,5,9,7,3,5,2</span>`} auto={true} />
                                        </div>
                                        <div className="language-html m-0 rounded-4 mt-3" data-lang="html">
                                            <pre className='h6 text-black'><code>**JavaScript**</code></pre>
                                            <CodeBox code={`<CommonBarChart className='bar' data={[5, 3, 9, 6, 5, 9, 7, 3, 5, 2]} />`} auto={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PeityCharts